import * as React from "react";

import { useAIChat } from "./AIChatContext";
import { Chat } from "./Chat";
import { ChatHistoryView } from "./ChatHistoryView/ChatHistoryView";
import styles from "./ChatSidebarMainContent.module.css";
import { EarlyAccessBanner } from "./EarlyAccessBanner";

/**
 * Shared main content component used by both the sidebar and fullscreen modal.
 * Handles the conditional rendering of chat views vs history.
 * Chat component handles all data fetching and mutations.
 */
export const ChatSidebarMainContent: React.FC = () => {
  const { showHistory } = useAIChat();

  return (
    <div className={styles.mainContainer}>
      <EarlyAccessBanner />
      {showHistory ? <ChatHistoryView /> : <Chat />}
    </div>
  );
};
